<template>
  <v-layout column class="farm-shipment-form">
    <v-container text-xs-center>
      <h2 class="title">New Shipment from Farms</h2>
    </v-container>
    <form>
      <v-container grid-list-md class="padding-top">
        <v-layout row wrap>
          <v-flex xs12>
            <v-select :items="farms" item-text="name" item-value="id" label="Select A Farm"
              v-model="form.location"
              @input="$v.form.location.$touch()"
              @blur="$v.form.location.$touch()"
              :error-messages="getFormErrorMessage('location')"
            ></v-select>
          </v-flex>
          <v-flex xs12>
            <v-select :items="ingredients" item-text="name" item-value="id" label="Type of Meat"
              v-model="form.ingredient"
              @input="$v.form.ingredient.$touch()"
              @blur="$v.form.ingredient.$touch()"
              :error-messages="getFormErrorMessage('ingredient')"
            ></v-select>
          </v-flex>
          <v-flex xs12>
            <v-menu full-width min-width="290px">
              <v-text-field
                slot="activator"
                :value="form.produced_at"
                label="Butchering Date"
                append-icon="date_range"
                :error-messages="getFormErrorMessage('produced_at')"
              ></v-text-field>
              <v-date-picker v-model="form.produced_at" no-title @input="$v.form.produced_at.$touch()"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12>
            <v-menu full-width min-width="290px">
              <v-text-field
                slot="activator"
                :value="form.shipped_at"
                label="Shipment Date (from Farm)"
                append-icon="date_range"
                @blur="$v.form.shipped_at.$touch()"
                :error-messages="getFormErrorMessage('shipped_at')"
              ></v-text-field>
              <v-date-picker v-model="form.shipped_at" no-title @input="$v.form.shipped_at.$touch()"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12>
            <v-text-field label="Meat Shipment number"
              :disabled="!!this.shipment.id"
              v-model="form.id"
              @input="$v.form.id.$touch()"
              @blur="$v.form.id.$touch();slugifyId();"
              :error-messages="getFormErrorMessage('id')"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
    </form>
    <v-layout row wrap>
      <v-container class="padding-top">
        <v-flex xs12>
          <v-btn @click="validateFormShipment()" raised block large color="primary" class="btn">save</v-btn>
        </v-flex>
        <v-flex xs12>
          <v-btn @click="handleClose()" flat block large color="primary" class="btn">cancel</v-btn>
        </v-flex>
      </v-container>
    </v-layout>
  </v-layout>

</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'
import slugify from '@sindresorhus/slugify'

export default {
  name: 'ShipmentForm',
  props: ['shipmentId', 'shipment'],
  computed: {
    ...mapGetters({
      farms: 'farms',
      ingredients: 'ingredients'
    })
  },
  data () {
    return {
      shipmentValidationErrorMsg: {},
      form: {
        location: '',
        ingredient: '',
        id: '',
        shipped_at: '',
        produced_at: ''
      }
    }
  },
  validations () {
    return {
      form: {
        location: { required },
        ingredient: { required },
        id: { required },
        shipped_at: { required },
        produced_at: { required }
      }
    }
  },
  created () {
    if (this.shipment && this.shipment.id) {
      this.form = {
        ...this.shipment
      }
      this.form.ingredient = this.form.ingredient.id
    }
  },
  methods: {

    slugifyId () {
      this.form.id = slugify(this.form.id, { lowercase: false, decamelize: false })
    },

    getFormErrorMessage (field) {
      let errors = []

      if (!this.$v.form[field].$dirty) return errors
      for (let key in this.$v.form[field].$params) {
        // Add more key here is needed for other type of error messages
        if (key === 'required') !this.$v.form[field].required && errors.push('This field is is required.')
      }

      if (this.shipmentValidationErrorMsg[field]) {
        errors.push(this.shipmentValidationErrorMsg[field][0])
      }

      return errors
    },

    handleClose () {
      this.$emit('on-close-dialog')
    },

    validateFormShipment () {
      if (this.$v.form.$invalid) {
        this.$v.form.$touch()
      } else {
        this.createShipment()
      }
    },

    createShipment () {
      let shipmentData = JSON.parse(JSON.stringify(this.form))
      this.slugifyId()
      this.$store.dispatch('checkShipmentId', shipmentData.id).then((res) => {
        if (res === 'exists') {
          // Update Shipment
          if (shipmentData.lot === null) {
            delete shipmentData.lot
          }
          this.$store.dispatch('updateShipment', { shipment: shipmentData }).then(() => {
            this.$store.dispatch('showSnackBar', { message: 'Shipment updated successfully.' })
            this.$emit('on-close-dialog')
          })
        } else {
          this.$store.dispatch('createShipment', { shipment: shipmentData }).then(() => {
            this.$store.dispatch('showSnackBar', { message: 'Shipment created successfully.' })
            this.$emit('on-close-dialog')
          }).catch((err) => {
            for (let key in err.response.data) {
              this.shipmentValidationErrorMsg[key] = err.response.data[key]
            }
            this.$v.$reset()
            this.$v.$touch()
          })
        }
      })
    }
  }
}

</script>

<style lang="scss" scoped>
.farm-shipment-form{
  padding: 5px 7px;
  .title{
    font-weight: 400;
    font-size: 24px !important;
  }
  .padding-top{
    padding-top: 0;
  }
  .btn{
    font-size: 18px;
    font-weight: 500;
  }
}
</style>
